export default __webpack_public_path__ + "static/media/homepage-banner2.3cb60c9d.png";